// Modular JS for Cart Drawer Shipping Progress Bar
(function(){
  function updateCartShippingBar(cart) {
    var barWrapper = document.querySelector('.cart-shipping-progress');
    if (!barWrapper) return;
    // Hide bar if cart is empty
    if (!cart || cart.item_count === 0) {
      barWrapper.style.display = 'none';
      return;
    } else {
      barWrapper.style.display = '';
    }
    var threshold = parseFloat(barWrapper.getAttribute('data-threshold')) || 200;
    var beforeTextRaw = barWrapper.getAttribute('data-before-text') || '';
    var afterText = barWrapper.getAttribute('data-after-text') || '';
    var beforeIcon = barWrapper.getAttribute('data-before-icon');
    var afterIcon = barWrapper.getAttribute('data-after-icon');
    var bg = barWrapper.getAttribute('data-bg') || '#e5e5e5';
    var fill = barWrapper.getAttribute('data-fill') || '#F996A2';
    var radius = +barWrapper.getAttribute('data-radius') || 10;
    var bar = barWrapper.querySelector('.cart-shipping-progress-bar');
    var textWrap = barWrapper.querySelector('.cart-shipping-progress-text');
    var msgSpan = textWrap.querySelector('.cart-shipping-progress-message');
    var iconImg = textWrap.querySelector('.cart-shipping-progress-icon');
    // Use items_subtotal_price for correct cart subtotal, fallback to total_price if needed
    var cartSubtotal = cart && typeof cart.items_subtotal_price !== "undefined"
      ? cart.items_subtotal_price / 100
      : (cart && cart.total_price ? cart.total_price / 100 : 0);
    var percent = Math.floor(100 * cartSubtotal / threshold);
    if (percent > 100) percent = 100;
    barWrapper.style.setProperty('--cart-progress-bg', bg);
    barWrapper.style.setProperty('--cart-progress-fill', fill);
    barWrapper.style.setProperty('--cart-progress-radius', radius + 'px');
    if (bar) bar.style.width = percent + '%';
    // Always clear out the span and any icons
    msgSpan.innerHTML = '';
    // Remove any leftover icon
    var oldIcons = textWrap.querySelectorAll('.cart-shipping-progress-icon');
    oldIcons.forEach(function(icon){ icon.remove(); });
    if (cartSubtotal >= threshold) {
      if (afterIcon) {
        let img = document.createElement('img');
        img.className = 'cart-shipping-progress-icon';
        img.src = afterIcon;
        img.alt = '';
        img.width = 24;
        img.height = 24;
        textWrap.insertBefore(img, msgSpan);
      }
      msgSpan.textContent = afterText;
    } else {
      var amountLeft = Math.ceil(threshold - cartSubtotal);
      if (beforeIcon) {
        let img = document.createElement('img');
        img.className = 'cart-shipping-progress-icon';
        img.src = beforeIcon;
        img.alt = '';
        img.width = 24;
        img.height = 24;
        textWrap.insertBefore(img, msgSpan);
      }
      var amountFormatted = '₪' + amountLeft;
      var msg = beforeTextRaw.split('{amount}').join(amountFormatted);
      msgSpan.innerHTML = msg;
    }
  }
  // Attempt AJAX cart event support (most modern themes)
  document.addEventListener('cart:updated', function(e) {
    updateCartShippingBar(e.detail && e.detail.cart ? e.detail.cart : null);
  });
  window.updateCartShippingBar = updateCartShippingBar; // expose for manual updates

  var lastState = false;
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        var isOpen = drawer.classList.contains('drawer--is-open');
        var isEmpty = drawer.classList.contains('is-empty');
        if (isOpen && !isEmpty && !lastState) {
          if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
            window.theme.cart.getCart().then(function(cart) {
              updateCartShippingBar(cart);
            });
          } else {
            updateCartShippingBar();
          }
        }
        lastState = isOpen && !isEmpty;
      }
    });
  });
  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
